import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardBlockedSendersOption')(function discardBlockedSendersOption(state) {
    var optionState = state.optionState;
    optionState.blockedSenders = null;
}));
//# sourceMappingURL=discardBlockedSendersOption.js.map